import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import MessageUI from '../../../widgets/output/MessageUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonLinkUI from '../../../widgets/action/ButtonLinkUI'
import ErrorMessageUI from '../../../widgets/form/ErrorMessageUI'
import SuccessMessageUI from '../../../widgets/form/SuccessMessageUI'
import PriceViewUI from './PriceViewUI'
import './SubscriptionView.css'

const SubscriptionViewUI = ({context, messageList, subscription, priceList, errorList, errorCode, successMsg,
  updateMode, onUpdateClick, onCancelUpdateClick, onUpdateSubmit, updateSubmitted,
  cancelMode, onCancelClick, onCancelCancelClick, onCancelSubmit, cancelSubmitted,
  }) =>
  <CardUI className='sub_view'>
    <SuccessMessageUI className='msg' successMsg={successMsg} />
    <ErrorMessageUI className='msg' errorList={errorList} />
    {
      errorCode === 'CreditCardNotValid' &&
      <div className='g_text_right'>
        <ButtonLinkUI context={context} messageList={messageList} labelKey='c_update_card'
          to='/settings/account/billing'
        />
        <div className='g_m_top_100' />
      </div>
    }
    <SpinnerUI show={updateSubmitted} />

    <div className='price_list'>
      {
        priceList.map((price, i) =>
          <PriceViewUI key={i} context={context} messageList={messageList}
            selectedPriceId={subscription.priceId} price={price}
            selectMode={updateMode}
            onSelect={onUpdateSubmit}
          />
        )
      }
    </div>

    {
      !updateMode &&
      <div className='bill_date'>
        {
          subscription.trialEndDate &&
          <React.Fragment>
            <div className='g_small g_muted'>
              <MessageUI messageList={messageList} messageKey='c_trial_ends' />
            </div>
            <div>{subscription.trialEndDate}</div>
          </React.Fragment>
        }
        {
          subscription.nextBillDate &&
          <React.Fragment>
            <div className='g_small g_muted g_m_top_25'>
              <MessageUI messageList={messageList} messageKey='c_next_bill_date' />{' '}
            </div>
            <div>{subscription.nextBillDate}</div>
          </React.Fragment>
        }
      </div>
    }

    {
      /* update and cancel buttons */
      !updateMode && !cancelMode &&
      <div className='g_flex_h actions upd_cncl'>
        <ButtonUI
          messageList={messageList}
          labelKey='c_update_subscription'
          transparent={true}
          onClick={onUpdateClick} />
        <ButtonUI
          messageList={messageList}
          labelKey='c_cancel_subscription'
          transparent={true}
          onClick={onCancelClick} />
      </div>
    }

    {
      /* update mode */
      updateMode && subscription.priceId &&
      <div className='g_flex_h actions'>
        <span />
        <ButtonUI
          messageList={messageList}
          labelKey='c_cancel'
          transparent={true}
          onClick={onCancelUpdateClick} />
      </div>
    }

    {
      /* cancel mode */
      cancelMode && subscription.priceId &&
      <div className='actions g_text_right'>
        <MessageUI messageList={messageList} messageKey='c_cancel_sub_confirm' />
        <div className='g_flex_h actions cancel'>
          <ButtonUI
            messageList={messageList}
            labelKey='c_do_not_cancel'
            transparent={true}
            onClick={onCancelCancelClick} />
          <SpinnerUI show={cancelSubmitted} />
          <ButtonUI
            messageList={messageList}
            labelKey='c_yes_cancel'
            onClick={onCancelSubmit}
            disabled={cancelSubmitted} />
        </div>
      </div>
    }
  </CardUI>

export default SubscriptionViewUI
